var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5001 87.2084H34.5001C13.6851 87.2084 4.79175 78.3151 4.79175 57.5001V34.5001C4.79175 13.6851 13.6851 4.79175 34.5001 4.79175H57.5001C78.3151 4.79175 87.2084 13.6851 87.2084 34.5001V57.5001C87.2084 78.3151 78.3151 87.2084 57.5001 87.2084ZM34.5001 10.5417C16.8284 10.5417 10.5417 16.8284 10.5417 34.5001V57.5001C10.5417 75.1718 16.8284 81.4584 34.5001 81.4584H57.5001C75.1718 81.4584 81.4584 75.1718 81.4584 57.5001V34.5001C81.4584 16.8284 75.1718 10.5417 57.5001 10.5417H34.5001Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7468 68.0416H39.2151C34.9984 68.0416 31.6634 65.9716 29.7851 62.2149L26.3734 55.3532C25.5684 53.7049 23.9201 52.7083 22.0801 52.7083H7.62842C6.05675 52.7083 4.75342 51.4049 4.75342 49.8333C4.75342 48.2616 6.09508 46.9583 7.66675 46.9583H22.0801C26.1051 46.9583 29.7084 49.1816 31.5101 52.7849L34.9218 59.6466C35.8034 61.4099 37.2217 62.2916 39.2151 62.2916H52.7468C54.5868 62.2916 56.2351 61.2949 57.0401 59.6466L60.4518 52.7849C62.2534 49.1816 65.8568 46.9583 69.8818 46.9583H84.2184C85.7901 46.9583 87.0934 48.2616 87.0934 49.8333C87.0934 51.4049 85.7901 52.7083 84.2184 52.7083H69.8818C68.0417 52.7083 66.3934 53.7049 65.5884 55.3532L62.1768 62.2149C60.3751 65.8182 56.7718 68.0416 52.7468 68.0416Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.a89fdd37c96bdab17e685f984296956e.svg";
export { ForwardRef as ReactComponent };